// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__33KUs","consentsList":"PatientConsents_consentsList__1Ud9n","consentsListEmpty":"PatientConsents_consentsListEmpty__gI1he"};